import React from 'react'

export const AlertComponent = ({ type, children, className = 'm-20' }) => (
  <div className={`alert alert-${type} ${className}`} role="alert" data-test="alertComponentTest">
    {children}
  </div>
)
